"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveExposeVouchers = exports.GetExposeVouchers = exports.ReportVoucherType = exports.ReportUserVouchers = exports.ReportVoucher = exports.GetRuleIdsByVoucherTypeIds = exports.GetRulesVoucherTypeIds = exports.GetMultiSimpleVoucherType = exports.UserHasAvailablePrimeVoucher = exports.UserGetMyVouchersByCategory = exports.UserGetVoucherCategoryCount = exports.UserGetVoucherStatusCount = exports.UserGetAvailableVoucherCount = exports.UserGetMyVouchers = exports.GetMultiVoucher = exports.Receive = exports.UserGetMultiVoucherType = exports.GetUserMultiSimpleVoucherType = exports.GetShipments = exports.UpdateRuleId = exports.DecacheRedisUserVoucher = exports.GetVoucherTypeUsage = exports.GetMultiVoucherTypeForServer = exports.UpdateEndDate = exports.IncreaseVoucher = exports.GetVoucherType = exports.MultiUnUse = exports.MultiUse = exports.MultiGiveByLoadIn = exports.Give = exports.Create = exports.Ping = exports.ExposeType = exports.VPage = exports.Area = exports.ChannelId = exports.VoucherStatus = exports.ServiceType = exports.VoucherCategory = void 0;
var webapi_1 = require("../webapi");
var VoucherCategory;
(function (VoucherCategory) {
    VoucherCategory["FullCut"] = "FullCut";
    VoucherCategory["Cash"] = "Cash";
    VoucherCategory["PrimeTrial"] = "PrimeTrial";
    VoucherCategory["AgentFee"] = "AgentFee";
    VoucherCategory["Shipping"] = "Shipping";
    VoucherCategory["AllCategory"] = "AllCategory";
})(VoucherCategory = exports.VoucherCategory || (exports.VoucherCategory = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["ServiceTypeAll"] = "ServiceTypeAll";
    ServiceType["ServiceTypeOther"] = "ServiceTypeOther";
    ServiceType["ServiceTypeBuy4Me"] = "ServiceTypeBuy4Me";
    ServiceType["ServiceTypeShip4Me"] = "ServiceTypeShip4Me";
    ServiceType["ServiceTypeEzbuy"] = "ServiceTypeEzbuy";
    ServiceType["ServiceTypePrime"] = "ServiceTypePrime";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var VoucherStatus;
(function (VoucherStatus) {
    VoucherStatus["VAll"] = "VAll";
    VoucherStatus["VUnUsed"] = "VUnUsed";
    VoucherStatus["VUsed"] = "VUsed";
    VoucherStatus["VExpired"] = "VExpired";
    VoucherStatus["VUnAvailable"] = "VUnAvailable";
    VoucherStatus["VUnknown"] = "VUnknown";
})(VoucherStatus = exports.VoucherStatus || (exports.VoucherStatus = {}));
var ChannelId;
(function (ChannelId) {
    ChannelId["Other"] = "Other";
    ChannelId["SlotMachine"] = "SlotMachine";
    ChannelId["Champagne"] = "Champagne";
    ChannelId["NewRegister"] = "NewRegister";
    ChannelId["SignIn"] = "SignIn";
    ChannelId["TopUP"] = "TopUP";
    ChannelId["CashOff"] = "CashOff";
    ChannelId["Tights"] = "Tights";
    ChannelId["PageDetail"] = "PageDetail";
})(ChannelId = exports.ChannelId || (exports.ChannelId = {}));
var Area;
(function (Area) {
    Area["AllArea"] = "AllArea";
    Area["China"] = "China";
    Area["America"] = "America";
    Area["Taiwan"] = "Taiwan";
    Area["Korea"] = "Korea";
})(Area = exports.Area || (exports.Area = {}));
var VPage;
(function (VPage) {
    VPage["VPageProductDetail"] = "VPageProductDetail";
})(VPage = exports.VPage || (exports.VPage = {}));
var ExposeType;
(function (ExposeType) {
    ExposeType["ExposeTypeNormal"] = "ExposeTypeNormal";
    ExposeType["ExposeTypeMillion"] = "ExposeTypeMillion";
    ExposeType["ExposeTypeFlash"] = "ExposeTypeFlash";
})(ExposeType = exports.ExposeType || (exports.ExposeType = {}));
function Ping(payload) {
    return webapi_1.default("nadesico.Voucher/Ping", payload);
}
exports.Ping = Ping;
function Create(payload) {
    return webapi_1.default("nadesico.Voucher/Create", payload);
}
exports.Create = Create;
function Give(payload) {
    return webapi_1.default("nadesico.Voucher/Give", payload);
}
exports.Give = Give;
function MultiGiveByLoadIn(payload) {
    return webapi_1.default("nadesico.Voucher/MultiGiveByLoadIn", payload);
}
exports.MultiGiveByLoadIn = MultiGiveByLoadIn;
function MultiUse(payload) {
    return webapi_1.default("nadesico.Voucher/MultiUse", payload);
}
exports.MultiUse = MultiUse;
function MultiUnUse(payload) {
    return webapi_1.default("nadesico.Voucher/MultiUnUse", payload);
}
exports.MultiUnUse = MultiUnUse;
function GetVoucherType(payload) {
    return webapi_1.default("nadesico.Voucher/GetVoucherType", payload);
}
exports.GetVoucherType = GetVoucherType;
function IncreaseVoucher(payload) {
    return webapi_1.default("nadesico.Voucher/IncreaseVoucher", payload);
}
exports.IncreaseVoucher = IncreaseVoucher;
function UpdateEndDate(payload) {
    return webapi_1.default("nadesico.Voucher/UpdateEndDate", payload);
}
exports.UpdateEndDate = UpdateEndDate;
function GetMultiVoucherTypeForServer(payload) {
    return webapi_1.default("nadesico.Voucher/GetMultiVoucherTypeForServer", payload);
}
exports.GetMultiVoucherTypeForServer = GetMultiVoucherTypeForServer;
function GetVoucherTypeUsage(payload) {
    return webapi_1.default("nadesico.Voucher/GetVoucherTypeUsage", payload);
}
exports.GetVoucherTypeUsage = GetVoucherTypeUsage;
function DecacheRedisUserVoucher(payload) {
    return webapi_1.default("nadesico.Voucher/DecacheRedisUserVoucher", payload);
}
exports.DecacheRedisUserVoucher = DecacheRedisUserVoucher;
function UpdateRuleId(payload) {
    return webapi_1.default("nadesico.Voucher/UpdateRuleId", payload);
}
exports.UpdateRuleId = UpdateRuleId;
function GetShipments(payload) {
    return webapi_1.default("nadesico.Voucher/GetShipments", payload);
}
exports.GetShipments = GetShipments;
function GetUserMultiSimpleVoucherType(payload) {
    return webapi_1.default("nadesico.Voucher/GetUserMultiSimpleVoucherType", payload);
}
exports.GetUserMultiSimpleVoucherType = GetUserMultiSimpleVoucherType;
function UserGetMultiVoucherType(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetMultiVoucherType", payload);
}
exports.UserGetMultiVoucherType = UserGetMultiVoucherType;
function Receive(payload) {
    return webapi_1.default("nadesico.Voucher/Receive", payload);
}
exports.Receive = Receive;
function GetMultiVoucher(payload) {
    return webapi_1.default("nadesico.Voucher/GetMultiVoucher", payload);
}
exports.GetMultiVoucher = GetMultiVoucher;
function UserGetMyVouchers(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetMyVouchers", payload);
}
exports.UserGetMyVouchers = UserGetMyVouchers;
function UserGetAvailableVoucherCount(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetAvailableVoucherCount", payload);
}
exports.UserGetAvailableVoucherCount = UserGetAvailableVoucherCount;
function UserGetVoucherStatusCount(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetVoucherStatusCount", payload);
}
exports.UserGetVoucherStatusCount = UserGetVoucherStatusCount;
function UserGetVoucherCategoryCount(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetVoucherCategoryCount", payload);
}
exports.UserGetVoucherCategoryCount = UserGetVoucherCategoryCount;
function UserGetMyVouchersByCategory(payload) {
    return webapi_1.default("nadesico.Voucher/UserGetMyVouchersByCategory", payload);
}
exports.UserGetMyVouchersByCategory = UserGetMyVouchersByCategory;
function UserHasAvailablePrimeVoucher(payload) {
    return webapi_1.default("nadesico.Voucher/UserHasAvailablePrimeVoucher", payload);
}
exports.UserHasAvailablePrimeVoucher = UserHasAvailablePrimeVoucher;
function GetMultiSimpleVoucherType(payload) {
    return webapi_1.default("nadesico.Voucher/GetMultiSimpleVoucherType", payload);
}
exports.GetMultiSimpleVoucherType = GetMultiSimpleVoucherType;
function GetRulesVoucherTypeIds(payload) {
    return webapi_1.default("nadesico.Voucher/GetRulesVoucherTypeIds", payload);
}
exports.GetRulesVoucherTypeIds = GetRulesVoucherTypeIds;
function GetRuleIdsByVoucherTypeIds(payload) {
    return webapi_1.default("nadesico.Voucher/GetRuleIdsByVoucherTypeIds", payload);
}
exports.GetRuleIdsByVoucherTypeIds = GetRuleIdsByVoucherTypeIds;
function ReportVoucher(payload) {
    return webapi_1.default("nadesico.Voucher/ReportVoucher", payload);
}
exports.ReportVoucher = ReportVoucher;
function ReportUserVouchers(payload) {
    return webapi_1.default("nadesico.Voucher/ReportUserVouchers", payload);
}
exports.ReportUserVouchers = ReportUserVouchers;
function ReportVoucherType(payload) {
    return webapi_1.default("nadesico.Voucher/ReportVoucherType", payload);
}
exports.ReportVoucherType = ReportVoucherType;
function GetExposeVouchers(payload) {
    return webapi_1.default("nadesico.Voucher/GetExposeVouchers", payload);
}
exports.GetExposeVouchers = GetExposeVouchers;
function ReceiveExposeVouchers(payload) {
    return webapi_1.default("nadesico.Voucher/ReceiveExposeVouchers", payload);
}
exports.ReceiveExposeVouchers = ReceiveExposeVouchers;
exports.default = {
    Ping: Ping,
    Create: Create,
    Give: Give,
    MultiGiveByLoadIn: MultiGiveByLoadIn,
    MultiUse: MultiUse,
    MultiUnUse: MultiUnUse,
    GetVoucherType: GetVoucherType,
    IncreaseVoucher: IncreaseVoucher,
    UpdateEndDate: UpdateEndDate,
    GetMultiVoucherTypeForServer: GetMultiVoucherTypeForServer,
    GetVoucherTypeUsage: GetVoucherTypeUsage,
    DecacheRedisUserVoucher: DecacheRedisUserVoucher,
    UpdateRuleId: UpdateRuleId,
    GetShipments: GetShipments,
    GetUserMultiSimpleVoucherType: GetUserMultiSimpleVoucherType,
    UserGetMultiVoucherType: UserGetMultiVoucherType,
    Receive: Receive,
    GetMultiVoucher: GetMultiVoucher,
    UserGetMyVouchers: UserGetMyVouchers,
    UserGetAvailableVoucherCount: UserGetAvailableVoucherCount,
    UserGetVoucherStatusCount: UserGetVoucherStatusCount,
    UserGetVoucherCategoryCount: UserGetVoucherCategoryCount,
    UserGetMyVouchersByCategory: UserGetMyVouchersByCategory,
    UserHasAvailablePrimeVoucher: UserHasAvailablePrimeVoucher,
    GetMultiSimpleVoucherType: GetMultiSimpleVoucherType,
    GetRulesVoucherTypeIds: GetRulesVoucherTypeIds,
    GetRuleIdsByVoucherTypeIds: GetRuleIdsByVoucherTypeIds,
    ReportVoucher: ReportVoucher,
    ReportUserVouchers: ReportUserVouchers,
    ReportVoucherType: ReportVoucherType,
    GetExposeVouchers: GetExposeVouchers,
    ReceiveExposeVouchers: ReceiveExposeVouchers,
};
